import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'

export const pinia = createPinia()

pinia.use(
	createPersistedState({
		storage: localStorage
	})
)

//export default pinia
export * from './authStore'
export * from './baseStore'
export * from './clientStore'
export * from './commonStore'
export * from './configStore'
export * from './eventStore'
export * from './forecastStore'
export * from './jobStore'
export * from './notificationStore'
export * from './quoteStore'
export * from './siteCapacityStore'
export * from './subJobStore'
